import axios from 'axios';
import {OptionHTMLAttributes} from 'react';

export const MAX_UPLOAD_FILE_SIZE = 10000000;

const POST_NEWS_ROUTE: string = 'api/files';
const GET_ALL_COMMON_FILES_ROUTE: string = 'api/files/common';
const TOGGLE_FILE_VISIBILITY: string = 'api/files/common/:id/toggle';
const DELETE_FILE: string = 'api/files/:id/delete';
const RENAME_FILE: string = 'api/files/:id/rename';

export interface FileToUpload {
    fileName: string;
    category?: OptionHTMLAttributes<string>;
    langue?: OptionHTMLAttributes<string>;
    file?: File;
    visible: boolean;
    start_date?: string;
}

/**
 * Fichier déjà uploadé récupéré du backend
 */
export interface CommonFile extends FileToUpload {
    id: number;
    type: string;
    system: string;
    name: string;
}

export const uploadFile = async (file: FormData): Promise<boolean> => {
    try {
        await axios.post(`${POST_NEWS_ROUTE}`, file, {
            headers: {'Content-type': 'multipart/form-data'},
        });
    } catch (e) {
        return false;
    }
    return true;
};

export const getCommonFiles = async () => {
    const response = await axios.get<CommonFile[]>(GET_ALL_COMMON_FILES_ROUTE);
    return response.data;
};

export const toggleFileVisibility = async (id: number): Promise<CommonFile | null> => {
    let response = await axios.patch<CommonFile>(
        TOGGLE_FILE_VISIBILITY.replace(':id', id.toString())
    );
    if (!response) {
        throw new Error();
    }
    return response.data;
};

export const deleteFile = async (id: number): Promise<void> => {
    const response = await axios.delete(DELETE_FILE.replace(':id', id.toString()));
    if (!response) {
        throw new Error();
    }
};

export const renameFile = async (
    id: number,
    newName: string,
    langue?: string,
    file?: File
): Promise<CommonFile | null> => {
    const url = RENAME_FILE.replace(':id', id.toString());
    let response;
    if (file) {
        // PHP ne lit pas les fichiers d'une requête PATCH en multipart/form-data : on envoie
        // donc un POST avec `_method=PATCH`, reconnu nativement par Laravel (method spoofing).
        const formData = new FormData();
        formData.append('_method', 'PATCH');
        formData.append('fileName', newName);
        if (langue) {
            formData.append('langue', langue);
        }
        formData.append('file', file);
        response = await axios.post(url, formData, {
            headers: {'Content-type': 'multipart/form-data'},
        });
    } else {
        response = await axios.patch(url, {
            fileName: newName,
            langue,
        });
    }
    if (!response) {
        throw new Error();
    }
    return response.data;
};
